// Geographic + category data for CANARIAS MARKET
export const ISLANDS = [
  { id: "tenerife", name: "Tenerife", municipalities: ["Adeje", "Arafo", "Arico", "Arona", "Buenavista del Norte", "Candelaria", "Fasnia", "Garachico", "Granadilla de Abona", "La Guancha", "Guía de Isora", "Güímar", "Icod de los Vinos", "San Cristóbal de La Laguna", "La Matanza de Acentejo", "La Orotava", "Puerto de la Cruz", "Los Realejos", "El Rosario", "San Juan de la Rambla", "San Miguel de Abona", "Santa Cruz de Tenerife", "Santa Úrsula", "Santiago del Teide", "El Sauzal", "Los Silos", "Tacoronte", "El Tanque", "Tegueste", "La Victoria de Acentejo", "Vilaflor de Chasna"] },
  { id: "gran_canaria", name: "Gran Canaria", municipalities: ["Agaete", "Agüimes", "La Aldea de San Nicolás", "Artenara", "Arucas", "Firgas", "Gáldar", "Ingenio", "Mogán", "Moya", "Las Palmas de Gran Canaria", "San Bartolomé de Tirajana", "Santa Brígida", "Santa Lucía de Tirajana", "Santa María de Guía de Gran Canaria", "Tejeda", "Telde", "Teror", "Valleseco", "Valsequillo de Gran Canaria", "Vega de San Mateo"] },
  { id: "lanzarote", name: "Lanzarote", municipalities: ["Arrecife", "Haría", "San Bartolomé", "Teguise", "Tías", "Tinajo", "Yaiza"] },
  { id: "fuerteventura", name: "Fuerteventura", municipalities: ["Antigua", "Betancuria", "La Oliva", "Pájara", "Puerto del Rosario", "Tuineje"] },
  { id: "la_palma", name: "La Palma", municipalities: ["Barlovento", "Breña Alta", "Breña Baja", "Fuencaliente de La Palma", "Garafía", "Los Llanos de Aridane", "El Paso", "Puntagorda", "Puntallana", "San Andrés y Sauces", "Santa Cruz de La Palma", "Tazacorte", "Tijarafe", "Villa de Mazo"] },
  { id: "la_gomera", name: "La Gomera", municipalities: ["Agulo", "Alajeró", "Hermigua", "San Sebastián de La Gomera", "Valle Gran Rey", "Vallehermoso"] },
  { id: "el_hierro", name: "El Hierro", municipalities: ["El Pinar de El Hierro", "Frontera", "Valverde"] },
  { id: "la_graciosa", name: "La Graciosa", municipalities: ["Caleta de Sebo", "Pedro Barba"] },
];

export const ISLAND_NAME = Object.fromEntries(ISLANDS.map((i) => [i.id, i.name]));

export const CATEGORIES = [
  { id: "moda", icon: "Shirt", color: "bg-pink-100 text-pink-700" },
  { id: "calzado", icon: "Footprints", color: "bg-amber-100 text-amber-700" },
  { id: "electronica", icon: "Smartphone", color: "bg-blue-100 text-blue-700" },
  { id: "hogar", icon: "Home", color: "bg-emerald-100 text-emerald-700" },
  { id: "coches", icon: "Car", color: "bg-red-100 text-red-700" },
  { id: "motos", icon: "Bike", color: "bg-orange-100 text-orange-700" },
  { id: "deportes", icon: "Waves", color: "bg-teal-100 text-teal-700" },
  { id: "videojuegos", icon: "Gamepad2", color: "bg-purple-100 text-purple-700" },
  { id: "bebes", icon: "Baby", color: "bg-sky-100 text-sky-700" },
  { id: "lujo_vintage", icon: "Sparkles", color: "bg-yellow-100 text-yellow-700" },
  { id: "bricolaje", icon: "Wrench", color: "bg-slate-200 text-slate-700" },
  { id: "libros", icon: "BookOpen", color: "bg-indigo-100 text-indigo-700" },
  { id: "musica", icon: "Music", color: "bg-rose-100 text-rose-700" },
  { id: "mascotas", icon: "Dog", color: "bg-lime-100 text-lime-700" },
  { id: "servicios", icon: "Briefcase", color: "bg-cyan-100 text-cyan-700" },
  { id: "coleccionismo", icon: "Trophy", color: "bg-amber-100 text-amber-800" },
  { id: "otros", icon: "Grid3x3", color: "bg-gray-100 text-gray-700" },
];

export const CONDITIONS = ["nuevo", "como_nuevo", "buen_estado", "usado"];
export const DELIVERY = ["recogida", "envio", "ambos"];
export const DISTANCES = [1, 5, 10, 25, 50];
export const REPORT_REASONS = ["prohibido", "estafa", "falso", "spam", "falsificado", "conducta", "otro"];

export const BOOST_PACKAGES = [
  { days: 1, price: 1.99, key: "b1" },
  { days: 3, price: 3.99, key: "b3" },
  { days: 7, price: 5.99, key: "b7" },
  { days: 15, price: 8.99, key: "b15" },
  { days: 30, price: 14.99, key: "b30" },
];

// Courier: Correos is the only shipping provider on the platform.
export const COURIERS = [
  { id: "correos", name: "Correos", url: "https://www.correos.es/es/es/herramientas/localizador/envios/detalle?tracking-number={code}" },
];

export const courierLink = (id, code) => {
  const c = COURIERS.find((x) => x.id === id);
  return c?.url && code ? c.url.replace("{code}", encodeURIComponent(code)) : null;
};

export const courierLabel = (order) => {
  if (!order?.carrier) return "";
  if (order.carrier === "otro") return order.carrier_name || "Otro";
  const c = COURIERS.find((x) => x.id === order.carrier);
  return c ? c.name : order.carrier;
};
